import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { isMobile } from "react-device-detect"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Video from "../elements/Video"
import Tags from "../elements/Tags"

import event_1 from "../../images/events/april/event-1.mp4"
import event_5 from "../../images/events/april/event-5.mp4"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". event-3 event-3 event-3" ". event-4 event-4 event-4" "event-8 event-8 event-8 ." "event-5 event-5 event-5 ." ". event-6 event-6 event-6" "event-7 event-7 event-7 ." ". . culture-1 culture-1";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
  }
  .event-4 {
    grid-area: event-4;
  }
  .event-5 {
    grid-area: event-5;
  }
  .event-6 {
    grid-area: event-6;
  }
  .event-7 {
    grid-area: event-7;
  }
  .event-8 {
    grid-area: event-8;
  }
  .culture-1 {
    grid-area: culture-1;
    align-self: flex-end;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" "event-3 event-3 event-2 event-2" "event-3 event-3 event-4 event-4" "event-8 event-8 event-4 event-4" "event-8 event-8 . ." ". event-5 event-5 ." ". . event-6 event-6" "event-7 event-7 event-6 event-6" "event-7 event-7 culture-1 ." ". . culture-1 .";
  }
  @media (min-width: 1200px) {
  }
`

const April = () => {
  const data = useStaticQuery(graphql`
    query {
      aprilEventOneFB: file(
        relativePath: { eq: "events/april/event-1-fb.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 445, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilEventTwo: file(relativePath: { eq: "events/april/event-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilEventThree: file(relativePath: { eq: "events/april/event-3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilEventFour: file(relativePath: { eq: "events/april/event-4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 595, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilEventFiveFB: file(
        relativePath: { eq: "events/april/event-5-fb.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 700, maxHeight: 421, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilEventSix: file(relativePath: { eq: "events/april/event-6.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilEventSeven: file(relativePath: { eq: "events/april/event-7.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilEventEight: file(relativePath: { eq: "events/april/event-8.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 501, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      aprilCultureOne: file(
        relativePath: { eq: "events/april/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="april">
      <Grid>
        <Block className="event-1">
          {isMobile ? (
            <Photo img={data.aprilEventOneFB} maxWidth={800} maxHeight={445} />
          ) : (
            <Video src={event_1} width={798} height={510} />
          )}
          <h4 style={{ maxWidth: 800 }}>
            Teamgeek’s new website went live, and with it the start of a new
            era. Go play{" "}
            <a
              href="https://teamgeek.io/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              here
            </a>
            .
          </h4>
          <Tags maxWidth={400} words={["react", "gatsbyjs", "threejs"]} />
        </Block>
        <Block className="event-2">
          <Photo img={data.aprilEventTwo} maxWidth={600} maxHeight={600} />
          <h4 style={{ maxWidth: 600 }}>
            <a
              href="https://www.google.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Google
            </a>{" "}
            and{" "}
            <a
              href="https://www.awwwards.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              AWWWARDS
            </a>{" "}
            gave our site a shout out for Mobile Excellence 🤘
          </h4>
        </Block>
        <Block className="event-3">
          <Photo img={data.aprilEventThree} maxWidth={600} maxHeight={600} />
          <h4 style={{ maxWidth: 600 }}>
            And it got named{" "}
            <a
              href="https://www.cssdesignawards.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              CSS Design Awards
            </a>
            ’ Website of the Day.
          </h4>
        </Block>
        <Block className="event-4">
          <Photo img={data.aprilEventFour} maxWidth={600} maxHeight={595} />
          <h4 style={{ maxWidth: 600 }}>
            People dug it too. It got the people’s vote.
          </h4>
        </Block>
        <Block className="event-8">
          <Photo img={data.aprilEventEight} maxWidth={500} maxHeight={501} />
          <h4 style={{ maxWidth: 500 }}>
            And got an honourable mention from{" "}
            <a
              href="https://www.awwwards.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              AWWWARDS
            </a>
            .
          </h4>
        </Block>
        <Block className="event-5">
          {isMobile ? (
            <Photo img={data.aprilEventFiveFB} maxWidth={700} maxHeight={421} />
          ) : (
            <Video src={event_5} width={602} height={360} />
          )}
          <h4 style={{ maxWidth: 800 }}>
            We launched a shiny new website for{" "}
            <a
              href="https://www.23law.co.za/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Nothnagel Attorneys
            </a>
            .
          </h4>
          <Tags maxWidth={400} words={["react", "gatsbyjs", "gsap"]} />
        </Block>
        <Block className="event-6">
          <Photo img={data.aprilEventSix} maxWidth={600} maxHeight={600} />
          <h4 style={{ maxWidth: 600 }}>
            The site got an honourable mention and an award for Mobile
            Excellence from{" "}
            <a
              href="https://www.google.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Google
            </a>{" "}
            and{" "}
            <a
              href="https://www.awwwards.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              AWWWARDS
            </a>
            .
          </h4>
        </Block>
        <Block className="event-7">
          <Photo img={data.aprilEventSeven} maxWidth={600} maxHeight={600} />
          <h4 style={{ maxWidth: 600 }}>
            And{" "}
            <a
              href="https://www.cssdesignawards.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              CSS Design Awards
            </a>{" "}
            gave us Special Kudos.
          </h4>
        </Block>
        <Block className="culture-1">
          <Photo img={data.aprilCultureOne} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>
            Duran made another orbit around the sun.
          </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default April
